/**
 * Remembers which plan a visitor asked for when they clicked "Start free
 * trial" on the landing page. Registration alone never starts a trial —
 * only Stripe checkout does — so the intent is parked in localStorage
 * across the signup → login redirect and consumed by AppShell once the
 * user is inside the app, which sends them straight to checkout.
 */
export const PENDING_PLAN_STORAGE_KEY = 'ft-pending-plan';

const safe = (fn) => { try { return fn(); } catch { return null; } };

export const setPendingPlan = (planKey) => {
  if (!planKey) return;
  safe(() => localStorage.setItem(PENDING_PLAN_STORAGE_KEY, String(planKey)));
};

export const peekPendingPlan = () => safe(() => localStorage.getItem(PENDING_PLAN_STORAGE_KEY)) || null;

export const clearPendingPlan = () => { safe(() => localStorage.removeItem(PENDING_PLAN_STORAGE_KEY)); };
